import { IData } from '../interface';

const getGAToken = (data: IData) => {
    if (data.SYSTEM === '"JP"' || data.SYSTEM === 'JP') {
        return `
            ga('create', 'UA-68036555-3', 'auto');
        `;
    } else if (data.SYSTEM === '"EN"' || data.SYSTEM === 'EN') {
        return `
            if (location.host.indexOf('umu.hk') > -1) {
                ga('create', 'UA-68036555-8', 'auto');
            } else {
                ga('create', 'UA-68036555-1', 'auto');
            }
        `;
    } else if (data.SYSTEM === '"TW"' || data.SYSTEM === 'TW') {
        return `
            ga('create', 'UA-68036555-2', 'auto');
        `;
    }

    return '';
};

const render = (data: IData) => {
    if (!data.IS_PRODUCTION) {
        return '';
    }

    if (data.SYSTEM === '"EM"' || data.SYSTEM === 'EM') {
        return `
            <script async src="https://www.googletagmanager.com/gtag/js?id=G-B26T7Z3FFG"></script>
            <script>
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());

                gtag('config', 'G-B26T7Z3FFG');
            </script>
            `;
    }

    if (data.SYSTEM === '"CN"' || data.SYSTEM === 'CN') {
        return `
            <script src="//cbe.huiju.cool/cbe/collect?tid=3342535601506082668&at=0&h=web"></script>
            <script>
                clab_tracker.ready(function(){
                    this.push({"pageType":"web"});
                    this.track("open_page", {});
                });
            </script>
            <script>
                var _hmt = _hmt || [];
                (function() {
                    var hm = document.createElement("script");
                    hm.src = "//hm.baidu.com/hm.js?0dda0edb8e4fbece1e49e12fc49614dc";
                    var s = document.getElementsByTagName("script")[0];
                    s.parentNode.insertBefore(hm, s);
                    var hm2 = document.createElement("script");
                    hm2.src = "https://hm.baidu.com/hm.js?1adfef4bdd11f6ed014f5b6df6b63302";
                    var s2 = document.getElementsByTagName("script")[0];
                    s2.parentNode.insertBefore(hm2, s2);
                })();
            </script>
            <script>
                var pathname = window.location.pathname || '';
                var queryNeedPath = ['cms', 'market', 'product', 'solution', 'home', 'thusem', 'plan', 'mercer'];
                var isNeed = false
                queryNeedPath.forEach(function(item) {
                    if (pathname.indexOf(item) !== -1) {
                        isNeed = true
                    }
                })
                if (isNeed) {
                    var orgOpen = window.open;
                    function formatNavigatedUrl(url) {
                        try {
                            var query = window.location.search
                            if (!query) {
                                return url
                            }
                            if (url.indexOf('?') !== -1) {
                                var urlOldQuery = url.split('?')[1];
                                var newQuery = query.split("?")[1];
                                var newQueryArr = newQuery.split('&');
                                var newQueryShowArr = [];
                                newQueryArr.forEach(function(item) {
                                    var itemKey = item.split('=')[0] || '';
                                    if (urlOldQuery.indexOf(itemKey) === -1) {
                                        newQueryShowArr.push(item)
                                    }
                                })
                                if (newQueryShowArr.length) {
                                    return url + '&' + newQueryShowArr.join('&')
                                } else {
                                    return url
                                }
                            } else {
                                return url + query
                            }
                        }catch(error) {
                            return url
                        }
                    }
                    window.open = function () {
                        var args = [].slice.call(arguments) || [];
                        if (!args[0]) {
                            return orgOpen();
                        }
                        args[0] = formatNavigatedUrl(args[0]);
                        return orgOpen(args[0], args[1] || '', args[2] || '');
                    }
                    window.addEventListener('click', function(event) {
                        var target = event.target || event.srcElement;
                        if (!target) {
                            return;
                        }
                        var hasADom = false;
                        try {
                            while (target) {
                                if (target && target.tagName === 'A') {
                                    hasADom = target
                                    break;
                                }
                                target = target.parentElement;
                            }
                        } catch(error) {
                            hasADom = false;
                        }
                        if (hasADom) {
                            var href = hasADom.getAttribute("href");
                            if (!href || href.includes('javascript:')) {
                                return
                            }
                            if (event.preventDefault) {
                                event.preventDefault();
                            } else {
                                event.returnValue = true;
                            }
                            var aTarget = hasADom.getAttribute("target");
                            var url = formatNavigatedUrl(href);
                            if (aTarget === "_blank") {
                                orgOpen(url);
                            } else {
                                window.location.href = url;
                            }
                        }
                    })
                }
            </script>
            `;
    }

    return `
        <script>
            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
            ${getGAToken(data)}
            ga('send', 'pageview');
        </script>
    `;
};

export default render;
